import * as React from "react";
import { Fragment } from "react";
import { Button, List, downloadCSV } from "react-admin";
import jsonExport from "jsonexport/dist";
import zoneAlerts from "../../defaults/ZoneAlerts";
import DataProvider from "../../DataProvider";

const ExportZonesButton = (props) => {
  const rapidResponseHeaders = [
    "ZONE",
    "DESCRIPTION",
    "SIGNALSTATUS",
    "SIGNALCLASS",
    "SIGNALCODE",
    "AREA",
    "EVENTCODE",
    "LOCATION",
    "TYPE",
  ];
  /**
   * Adds additional fields to a zone object based on the zone's properties.
   * @param {Object} zone - The zone object to modify.
   * @returns {Object} - The modified zone object.
   */
  function addZoneFields(zone) {
    let zoneAlert;
    for (const alert of zoneAlerts) {
      if (alert.id === zone.message_prefix) zoneAlert = alert;
    }
    const modifiedZone = { ...zoneAlert.rapidResponse };
    modifiedZone.ZONE = zone.customID;
    modifiedZone.DESCRIPTION = zone.name;
    modifiedZone.SIGNALCODE = `#SOS#${zone.id}`;
    return modifiedZone;
  }

  /**
   * Retrieves a list of zones for a given organization ID.
   * @param {string} orgid - The organization ID.
   * @returns {Promise<Object[]>} - A promise that resolves to an array of zone objects.
   */
  async function getZones(orgid) {
    const data = await DataProvider.getList("zones", {
      pagination: { page: 1, perPage: 10000000000 },
      sort: { field: "customID", order: "ASC" },
      filter: {
        OrganizationId: orgid,
      },
    });
    return data.data;
  }

  /**
   * Event handler for a button click.
   * Retrieves zones for an organization and exports them as CSV.
   * @returns {Promise<void>} - A promise that resolves when the export is complete.
   */
  async function handleClick() {
    const record = props.record;
    const org_id = record.id;
    const orgName = record.name;
    const Zones = await getZones(org_id);

    if (!Zones) return;
    const zoneExport = Zones.map((zone) => {
      const modifiedZone = addZoneFields(zone);
      return modifiedZone;
    });
    jsonExport(
      zoneExport,
      {
        headers: [...rapidResponseHeaders],
      },
      (err, csv) => {
        const exportName = `${orgName.replace(" ", "_")}-zones-${Date.now()}`;
        const filteredName = exportName.replace(" ", "");
        console.log(csv);
        downloadCSV(csv, filteredName); // download as 'posts.csv` file
      }
    );
  }

  return (
    <Fragment>
      <Button
        style={{
          fontSize: "10",
          color: "#03a9f4",
          borderRadius: "10px",
          textAlign: "center",
        }}
        label="Export Zones"
        onClick={handleClick}
      />
    </Fragment>
  );
};

export default ExportZonesButton;
